module.exports = __webpack_public_path__ + "img/h4.cd5d0102.png";